import { COLOR } from 'src/constants/colors'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import { LocationDataPropsType } from 'src/views/Service/Location'
import { RootState } from 'src/store/store'
import Span from 'src/components/atomic/atom/Span'
import ImageDetail from 'src/components/atomic/Molecules/ImageDetail'
import EmptyComponent from 'src/components/atomic/Molecules/EmptyComponent'
import LocationCurrentInfo from 'src/components/atomic/organisms/views/Location/LocationCurrentInfo'
import LocationHaveHistory from 'src/components/atomic/organisms/views/Location/LocationHaveHistory'
import LocationPlayBtn from 'src/components/atomic/organisms/views/Location/LocationPlayBtn'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'

const LocationTemplate = (props: { data: LocationDataPropsType }) => {
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { imageDetailFlag, selectPin, EmptyComponentStatus } = useAppSelector(
    (state: RootState) => state.LocationPage,
  )

  return (
    <>
      <Span
        option={'title'}
        $margin={setMediaStyle('34px 0 12px 0', '73px 0 12px 0', '14px 0 6px 0')}
      >
        {t('LOCATE.TITLE', { defaultValue: 'Locate your lost device on the map' })}
      </Span>
      <Span
        option="desc"
        color={COLOR.black70}
        $margin={setMediaStyle('0 0 16px 0', '0 0 24px 0', '0 0 16px 0')}
      >
        {t('LOCATE.DESCN', {
          defaultValue:
            '“Locate Device” enables location of your lost device since locked. When you find your lost device located, you may either store or delete the location data.',
        })}
      </Span>
      <LocationPlayBtn data={props.data} />
      <LocationCurrentInfo data={props.data} />
      {EmptyComponentStatus === 'default' ? (
        <LocationHaveHistory data={props.data} />
      ) : (
        <EmptyComponent
          option={EmptyComponentStatus}
          $margin={setMediaStyle('232px auto 0 auto', '50px auto 0 auto', '50px auto 0 auto')}
        />
      )}
      {imageDetailFlag && selectPin && <ImageDetail />}
    </>
  )
}
export default LocationTemplate
